import {isFeatureEnabled} from 'feature-flags';
import {match} from 'ts-pattern';

import {always, isNil, isNotNil, reject} from 'ramda';

import {BusinessCaseResponseBody} from '@dms/api/sales';
import {SaleVehicleResponseBody} from '@dms/api/vehicle';
import {featureFlags} from '@dms/feature-flags';

import {Nullish} from 'shared/web';

import {EntityHeaderFlag} from '../components/EntityHeader/EntityHeader';
import {getBusinessCaseStateFlag} from '../utils/getBusinessCaseStateFlag';
import {getBusinessCaseTradeTypeFlag} from '../utils/getBusinessCaseTradeTypeFlag';
import {getBusinessCaseTypeFlag} from '../utils/getBusinessCaseTypeFlag';
import {getVehicleTradeType} from '../utils/getVehicleTradeType';

const stockTypeFlag = (
  businessCase: BusinessCaseResponseBody | undefined,
  vehicle: SaleVehicleResponseBody | Nullish
) =>
  businessCase?.businessCaseState !== 'CONCEPT' && isNotNil(vehicle)
    ? getBusinessCaseTradeTypeFlag(getVehicleTradeType(vehicle, businessCase))
    : undefined;

export function useGetFlags(
  businessCase: BusinessCaseResponseBody | undefined,
  vehicle: SaleVehicleResponseBody | Nullish
): [EntityHeaderFlag[]] {
  const hasLinkedTradeIn =
    isFeatureEnabled(featureFlags.TRADE_IN) && isNotNil(businessCase?.linkedTradeInBusinessCaseId);

  const compositeType = match([businessCase?.businessCaseType, hasLinkedTradeIn])
    .with(['SELLING', true], always('SELLING_SWAP'))
    .with(['BUYING', true], always('BUYING_SWAP'))
    .otherwise(([type]) => type);

  const typeFlag = getBusinessCaseTypeFlag(compositeType);
  const stateFlag = getBusinessCaseStateFlag(businessCase?.businessCaseState);
  const stockFlag = stockTypeFlag(businessCase, vehicle);

  const flags = reject(isNil, [typeFlag, stockFlag, stateFlag]);

  return [flags];
}
